import React from "react";
import { Link } from "react-router-dom";
import { ArrowUp, Heart, Linkedin, Mail, Phone, Sparkles } from "lucide-react";

export default function Footer({ theme = "dark" }) {
  const isLight = theme === "light";
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className={`py-14 relative overflow-hidden transition-colors ${
      isLight ? "bg-slate-50 border-t border-slate-200 text-slate-700" : "bg-[#050811] border-t border-white/[0.08]"
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        <div className={`flex flex-col md:flex-row items-center justify-between gap-8 pb-12 border-b ${
          isLight ? "border-slate-200" : "border-white/[0.06]"
        }`}>
          
          {/* Brand info */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <div className="flex items-center gap-2.5 mb-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-cyan-400 text-white flex items-center justify-center font-black text-xs shadow-[0_0_15px_rgba(79,70,229,0.3)]">
                KN
              </div>
              <span className={`font-heading font-extrabold text-lg tracking-tight ${
                isLight ? "text-slate-900" : "text-white"
              }`}>
                KANNA NARENDRA KUMAR
              </span>
            </div>
            <p className={`text-xs font-mono max-w-sm ${
              isLight ? "text-slate-500" : "text-white/50"
            }`}>
              AEO/GEO & SEO Consultant · 8+ Years Driving B2B SaaS Organic Inbound Revenue
            </p>
          </div>

          {/* Quick links */}
          <div className={`flex flex-wrap items-center justify-center gap-6 text-xs font-mono uppercase tracking-wider ${
            isLight ? "text-slate-600" : "text-white/60"
          }`}>
            <Link to="/" className={isLight ? "hover:text-blue-600 transition-colors" : "hover:text-cyan-400 transition-colors"}>Overview</Link>
            <Link to="/ai-visibility-audit/" className={isLight ? "text-blue-600 font-semibold hover:text-blue-700 transition-colors" : "text-cyan-400 font-semibold hover:text-cyan-300 transition-colors"}>AI Visibility Audit</Link>
            <Link to="/blog/" className={isLight ? "hover:text-blue-600 transition-colors" : "hover:text-cyan-400 transition-colors"}>Blog</Link>
            <Link to="/casestudy/seismic/" className={isLight ? "hover:text-blue-600 transition-colors" : "hover:text-cyan-400 transition-colors"}>Case Studies</Link>
            <Link to="/#heo" className={isLight ? "hover:text-blue-600 transition-colors" : "hover:text-cyan-400 transition-colors"}>HEO Framework</Link>
            <Link to="/#contact" className={isLight ? "hover:text-blue-600 transition-colors" : "hover:text-cyan-400 transition-colors"}>Contact</Link>
          </div>

          {/* Back to top */}
          <button
            onClick={scrollToTop}
            className={`p-3 rounded-xl transition-all duration-200 group flex items-center gap-2 text-xs font-mono border cursor-pointer ${
              isLight 
                ? "bg-white hover:bg-slate-100 text-slate-700 border-slate-200 shadow-sm hover:border-slate-300" 
                : "bg-white/[0.05] hover:bg-gradient-to-r hover:from-indigo-600 hover:to-cyan-600 text-white border-white/[0.06] hover:border-cyan-500/30"
            }`}
            aria-label="Back to top"
          >
            <span>Back to top</span>
            <ArrowUp className="w-4 h-4 group-hover:-translate-y-0.5 transition-transform" />
          </button>
        </div>

        {/* Bottom row */}
        <div className={`pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs font-mono ${
          isLight ? "text-slate-500" : "text-white/40"
        }`}>
          <p>© {new Date().getFullYear()} Kanna Narendra Kumar. All rights reserved.</p>
          <div className="flex flex-wrap items-center justify-center sm:justify-end gap-x-3.5 gap-y-2 text-center">
            <a 
              href="https://www.linkedin.com/in/narendra-kumar-kanna/" 
              target="_blank" 
              rel="noreferrer"
              className={isLight ? "hover:text-blue-600 transition-colors" : "hover:text-white transition-colors"}
            >
              LinkedIn
            </a>
            <span className="hidden sm:inline">•</span>
            <a 
              href="mailto:narendrakumarkanna@gmail.com" 
              className={isLight ? "hover:text-blue-600 transition-colors" : "hover:text-white transition-colors"}
            >
              narendrakumarkanna@gmail.com
            </a>
            <span className="hidden sm:inline">•</span>
            <Link to="/" className={isLight ? "text-blue-600 hover:underline font-semibold" : "text-emerald-400 hover:text-white transition-colors"}>
              narendradigital.in
            </Link>
          </div>
        </div>

      </div>
    </footer>
  );
}
